// Path: ./src/hooks/useFlyerTags.ts
import { useState, useEffect, useCallback } from "react";
import { adminApiService } from "../utils/api";
import { GfFlyerTag } from "@swagger/typescript-fetch-goflyer";

export const useFlyerTags = () => {
  const [flyerTagsList, setFlyerTagsList] = useState<GfFlyerTag[]>(); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) maybe we should do the mapping here to create label

  const fetchFlyerTags = useCallback(async () => {
    try {
      const flyerTags =
        await adminApiService.getManyBaseGfFlyerTagAdminControllerGfFlyerTag();

      setFlyerTagsList(flyerTags.data);
    } catch (error) {
      console.error("Error fetching flyer tags:", error);
    }
  }, []);

  useEffect(() => {
    fetchFlyerTags();
  }, []);

  return { flyerTagsList, fetchFlyerTags };
};
